(function(){
  'use strict';

  function shopRoot(){
    try{
      var root=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root?window.Shopify.routes.root:'/';
      return root.charAt(root.length-1)==='/'?root:root+'/';
    }catch(e){return '/';}
  }

  function clean(value){
    return value===null||value===undefined?'':String(value).trim();
  }

  function checkoutLocale(){
    var full=(document.documentElement.lang||'en').toLowerCase().replace('_','-');
    return full.indexOf('pt')===0?'pt':full.slice(0,2);
  }

  function visiblePropertyLabel(key){
    if(!key||key.charAt(0)==='_')return key;
    var lang=checkoutLocale();
    var labels={
      en:{name:'Name',email:'Email',phone:'Phone',date:'Date',time:'Time',language:'Language',ticket:'Ticket type',option:'Selected option'},
      pt:{name:'Nome',email:'E-mail',phone:'Telefone',date:'Data',time:'Horário',language:'Idioma',ticket:'Tipo de ingresso',option:'Opção selecionada'},
      es:{name:'Nombre',email:'Correo electrónico',phone:'Teléfono',date:'Fecha',time:'Hora',language:'Idioma',ticket:'Tipo de entrada',option:'Opción seleccionada'},
      fr:{name:'Nom',email:'E-mail',phone:'Téléphone',date:'Date',time:'Heure',language:'Langue',ticket:'Type de billet',option:'Option sélectionnée'},
      de:{name:'Name',email:'E-Mail',phone:'Telefon',date:'Datum',time:'Uhrzeit',language:'Sprache',ticket:'Ticketart',option:'Ausgewählte Option'},
      it:{name:'Nome',email:'E-mail',phone:'Telefono',date:'Data',time:'Ora',language:'Lingua',ticket:'Tipo di biglietto',option:'Opzione selezionata'},
      nl:{name:'Naam',email:'E-mail',phone:'Telefoon',date:'Datum',time:'Tijd',language:'Taal',ticket:'Tickettype',option:'Geselecteerde optie'},
      ar:{name:'الاسم',email:'البريد الإلكتروني',phone:'الهاتف',date:'التاريخ',time:'الوقت',language:'اللغة',ticket:'نوع التذكرة',option:'الخيار المحدد'},
      he:{name:'שם',email:'אימייל',phone:'טלפון',date:'תאריך',time:'שעה',language:'שפה',ticket:'סוג כרטיס',option:'אפשרות שנבחרה'}
    };
    var dict=labels[lang]||labels.en;
    var normalized=key.toLowerCase().normalize?key.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,''):key.toLowerCase();
    if(['cliente','name'].indexOf(normalized)>-1)return dict.name;
    if(['email','e-mail'].indexOf(normalized)>-1)return dict.email;
    if(['whatsapp','phone','telefone'].indexOf(normalized)>-1)return dict.phone;
    if(['data do passeio','date','preferred date'].indexOf(normalized)>-1)return dict.date;
    if(['horario','time','preferred time'].indexOf(normalized)>-1)return dict.time;
    if(['idioma escolhido','language'].indexOf(normalized)>-1)return dict.language;
    if(['tipo de ingresso','ticket type'].indexOf(normalized)>-1)return dict.ticket;
    if(['opcao selecionada','selected option'].indexOf(normalized)>-1)return dict.option;
    return key;
  }

  function propertiesObject(value){
    if(!value)return {};
    var input=value;
    if(!Array.isArray(input)){
      var mapped={};
      Object.keys(input).forEach(function(rawKey){
        var key=visiblePropertyLabel(clean(rawKey));
        if(key)mapped[key]=input[rawKey];
      });
      return mapped;
    }
    var out={};
    input.forEach(function(row){
      if(!row)return;
      var key=visiblePropertyLabel(clean(row.name||row.key));
      if(!key)return;
      out[key]=row.value===undefined?'':row.value;
    });
    return out;
  }

  function normalizeItems(payload){
    var source=payload&&Array.isArray(payload.items)?payload.items:(payload&&Array.isArray(payload.line_items)?payload.line_items:[]);
    return source.map(function(item){
      var id=item&&(item.id||item.variant_id);
      var quantity=parseInt(item&&item.quantity,10)||0;
      if(!id||quantity<1)return null;
      var row={id:id,quantity:quantity};
      var props=propertiesObject(item.properties);
      if(Object.keys(props).length)row.properties=props;
      return row;
    }).filter(Boolean);
  }

  function normalizeAttributes(payload){
    var out={};
    var attrs=payload&&payload.attributes;
    if(attrs&&typeof attrs==='object'&&!Array.isArray(attrs)){
      Object.keys(attrs).forEach(function(key){
        if(attrs[key]!==null&&attrs[key]!==undefined)out[key]=String(attrs[key]);
      });
    }

    var noteAttrs=payload&&payload.note_attributes;
    if(Array.isArray(noteAttrs)){
      noteAttrs.forEach(function(row){
        if(!row)return;
        var key=clean(row.name||row.key);
        if(key)out[key]=row.value===undefined?'':String(row.value);
      });
    }else if(noteAttrs&&typeof noteAttrs==='object'){
      Object.keys(noteAttrs).forEach(function(key){
        if(noteAttrs[key]!==null&&noteAttrs[key]!==undefined)out[key]=String(noteAttrs[key]);
      });
    }

    var customer=payload&&payload.customer;
    if(customer&&typeof customer==='object'){
      var fullName=[clean(customer.first_name),clean(customer.last_name)].filter(Boolean).join(' ');
      if(fullName&&!out['PMY Customer Name'])out['PMY Customer Name']=fullName;
      if(clean(customer.email)&&!out['PMY Customer Email'])out['PMY Customer Email']=clean(customer.email);
      if(clean(customer.phone)&&!out['PMY Customer WhatsApp'])out['PMY Customer WhatsApp']=clean(customer.phone);
    }
    return out;
  }

  async function readError(response){
    try{
      var body=await response.clone().json();
      if(body&&body.description)return body.description;
      if(body&&body.message)return body.message;
      return JSON.stringify(body);
    }catch(e){
      try{return await response.clone().text();}catch(ignore){return '';}
    }
  }

  function mergeTrackingAttributes(payload){
    payload=payload||{};
    if(!window.PMYTracking||typeof window.PMYTracking.getOrderAttributes!=='function')return payload;
    var existing=Array.isArray(payload.note_attributes)?payload.note_attributes.slice():[];
    var names={};
    existing.forEach(function(row){if(row&&row.name)names[String(row.name)]=true;});
    try{
      window.PMYTracking.getOrderAttributes().forEach(function(row){
        if(!row||!row.name||names[String(row.name)])return;
        existing.push({name:String(row.name),value:String(row.value==null?'':row.value)});
        names[String(row.name)]=true;
      });
    }catch(e){}
    payload.note_attributes=existing;
    return payload;
  }

  function mergePostPurchaseAttributes(payload){
    payload=payload||{};
    if(!window.PMYPostPurchaseAttribution||typeof window.PMYPostPurchaseAttribution.getOrderAttributes!=='function')return payload;
    var existing=Array.isArray(payload.note_attributes)?payload.note_attributes.slice():[];
    var names={};
    existing.forEach(function(row){if(row&&row.name)names[String(row.name)]=true;});
    try{
      window.PMYPostPurchaseAttribution.getOrderAttributes().forEach(function(row){
        if(!row||!row.name||names[String(row.name)])return;
        existing.push({name:String(row.name),value:String(row.value==null?'':row.value)});
        names[String(row.name)]=true;
      });
    }catch(e){}
    payload.note_attributes=existing;
    return payload;
  }

  /* PMY 2026-10-15: call the Central through the signed Shopify App Proxy on the
     store's own domain. Since 08/10 the Central answers the old direct URL with a
     307 to this path, and browsers block that cross-origin redirect ("Failed to fetch"). */
  var CENTRAL_HOLD_ENDPOINT='/apps/pmy-central/hold';

  function bookingProp(props,keys){
    props=props||{};
    for(var i=0;i<keys.length;i+=1){
      if(props[keys[i]]!==undefined&&clean(props[keys[i]]))return clean(props[keys[i]]);
    }
    return '';
  }

  /* PMY 2026-10-13: these two regexes were double-escaped (\\d, \\b), so they
     never matched any real date/time and every checkout failed with
     "Availability could not be verified". */
  function normalizeBookingDate(value){
    var raw=clean(value),match=raw.match(/^(20\d{2})[-/.](\d{1,2})[-/.](\d{1,2})$/);
    return match?match[1]+'-'+String(match[2]).padStart(2,'0')+'-'+String(match[3]).padStart(2,'0'):'';
  }

  function normalizeBookingTime(value){
    var raw=clean(value),match=raw.match(/\b([01]?\d|2[0-3])[:hH]([0-5]\d)\b/);
    return match?String(match[1]).padStart(2,'0')+':'+match[2]:'';
  }

  function centralItemDetails(item){
    var props=item&&item.properties||{};
    var productId=bookingProp(props,['_PMY Product ID','PMY Product ID']);
    var date=normalizeBookingDate(bookingProp(props,['_PMY Date','Date','Data','Data do Passeio','Preferred Date','Tour Date']));
    var time=normalizeBookingTime(bookingProp(props,['_PMY Time','Time','Horário','Horario','Horário preferencial','Horario preferencial','Opção selecionada','Opcao selecionada','Selected option']));
    var language=bookingProp(props,['_PMY Language','Language','Idioma','Idioma Escolhido']);
    var productKey=clean(productId).split('/').pop();
    var reservationKey=(productKey||('variant-'+String(item&&item.id||'')))+'|'+date+'|'+time;
    return{
      productId:productId,
      date:date,
      time:time,
      language:language,
      key:reservationKey
    };
  }

  /* PMY 2026-10-13: experiences without a fixed departure time (transfers, Fado,
     massage, Sintra & Cascais) have no time slot in the central reservation system.
     They skip the capacity hold instead of blocking the whole checkout. */
  function needsCentralHold(item){
    return !!centralItemDetails(item).time;
  }

  function centralGroups(items){
    var groups={};
    items.forEach(function(item){
      var detail=centralItemDetails(item);
      if(!detail.date||!detail.time){
        throw new Error('Availability could not be verified for this booking. Please reselect the date and time.');
      }
      if(!groups[detail.key]){
        groups[detail.key]={
          key:detail.key,
          productId:detail.productId,
          date:detail.date,
          time:detail.time,
          language:detail.language,
          items:[]
        };
      }
      groups[detail.key].items.push({
        variantId:String(item.id),
        quantity:Number(item.quantity||0)
      });
    });
    return Object.keys(groups).map(function(key){return groups[key]});
  }

  function checkoutRequestId(){
    try{
      if(window.crypto&&typeof window.crypto.randomUUID==='function'){
        return 'web_'+window.crypto.randomUUID();
      }
    }catch(e){}
    return 'web_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,12);
  }

  async function centralJson(body){
    var response=await fetch(CENTRAL_HOLD_ENDPOINT,{
      method:'POST',
      headers:{'Content-Type':'text/plain;charset=UTF-8','Accept':'application/json'},
      body:JSON.stringify(body)
    });
    var payload={};
    try{payload=await response.json()}catch(e){}
    if(!response.ok||payload.success===false){
      var error=new Error(payload.error||'This departure is no longer available.');
      error.code=payload.code||'CENTRAL_AVAILABILITY_FAILED';
      error.availability=payload.availability||null;
      throw error;
    }
    return payload;
  }

  async function reserveCentralCapacity(payload,items,requestId){
    var attrs=normalizeAttributes(payload);
    var customer=payload&&payload.customer&&typeof payload.customer==='object'?payload.customer:{};
    var customerName=clean(attrs['PMY Customer Name'])||[clean(customer.first_name),clean(customer.last_name)].filter(Boolean).join(' ');
    var customerEmail=clean(attrs['PMY Customer Email'])||clean(attrs.Email)||clean(customer.email);
    var customerPhone=clean(attrs['PMY Customer WhatsApp'])||clean(attrs.Phone)||clean(customer.phone);
    return centralJson({
      action:'reserve',
      requestId:requestId,
      customer:{name:customerName,email:customerEmail,phone:customerPhone},
      attribution:{
        commercialSource:clean(attrs['PMY Commercial Source']),
        source:clean(attrs.order_referrer_source||attrs['PMY Last Source']||attrs['PMY First Source']),
        medium:clean(attrs['PMY UTM Medium']),
        channel:clean(attrs.order_referrer_channel),
        name:clean(attrs.order_referrer_name),
        utmSource:clean(attrs['PMY UTM Source']),
        utmMedium:clean(attrs['PMY UTM Medium']),
        utmCampaign:clean(attrs['PMY UTM Campaign']),
        gclid:clean(attrs['PMY GCLID']),
        gbraid:clean(attrs['PMY GBRAID']),
        wbraid:clean(attrs['PMY WBRAID']),
        fbclid:clean(attrs['PMY FBCLID'])
      },
      groups:centralGroups(items)
    });
  }

  function applyCentralHolds(payload,items,holds){
    var byKey={};
    (holds||[]).forEach(function(hold){
      var keys=hold&&Array.isArray(hold.keys)&&hold.keys.length?hold.keys:[hold&&hold.key];
      keys.filter(Boolean).forEach(function(key){byKey[key]=hold;});
    });
    items.forEach(function(item){
      if(!needsCentralHold(item))return;
      var detail=centralItemDetails(item),hold=byKey[detail.key];
      if(!hold||!hold.holdId)throw new Error('Central availability hold was not created for every selected ticket.');
      item.properties=item.properties||{};
      item.properties['_PMY Hold ID']=String(hold.holdId);
      item.properties['_PMY Hold Expires At']=String(hold.expiresAt||'');
    });

    payload.attributes=payload.attributes&&typeof payload.attributes==='object'&&!Array.isArray(payload.attributes)
      ?Object.assign({},payload.attributes)
      :{};
    if(holds.length===1){
      payload.attributes['PMY Hold ID']=String(holds[0].holdId);
      payload.attributes['PMY Hold Expires At']=String(holds[0].expiresAt||'');
    }else{
      payload.attributes['PMY Hold IDs']=holds.map(function(hold){return hold.holdId}).join(',');
    }
  }

  async function releaseCentralHolds(holdIds){
    if(!holdIds||!holdIds.length)return;
    try{
      await centralJson({action:'release',holdIds:holdIds});
    }catch(e){}
  }

  /* PMY 2026-10-15: carry the name, e-mail and phone typed in the booking
     drawer into Shopify's checkout, so the customer does not type them again. */
  function checkoutPrefill(payload){
    var c=payload&&payload.customer&&typeof payload.customer==='object'?payload.customer:{};
    var attrs=normalizeAttributes(payload);
    var email=clean(c.email)||clean(attrs['PMY Customer Email']);
    var phone=clean(c.phone)||clean(attrs['PMY Customer WhatsApp']);
    var full=clean([clean(c.first_name),clean(c.last_name)].filter(Boolean).join(' '))||clean(attrs['PMY Customer Name']);
    var parts=full.split(/\s+/).filter(Boolean);
    var first=parts.length>1?parts.slice(0,-1).join(' '):full;
    var last=parts.length>1?parts[parts.length-1]:'';
    var q=[];
    function add(key,value){if(value)q.push(encodeURIComponent(key)+'='+encodeURIComponent(value));}
    add('checkout[email]',email);
    add('checkout[shipping_address][first_name]',first);
    add('checkout[shipping_address][last_name]',last);
    add('checkout[shipping_address][phone]',phone);
    add('checkout[billing_address][first_name]',first);
    add('checkout[billing_address][last_name]',last);
    add('checkout[billing_address][phone]',phone);
    return q.length?'?'+q.join('&'):'';
  }

  async function start(payload){
    payload=mergeTrackingAttributes(payload||{});
    payload=mergePostPurchaseAttributes(payload);
    var items=normalizeItems(payload);
    if(!items.length)throw new Error('No valid items selected for checkout.');

    var requestId=checkoutRequestId();
    var holdIds=[];

    try{
      var heldItems=items.filter(needsCentralHold);
      if(heldItems.length){
        var reservation=await reserveCentralCapacity(payload,heldItems,requestId);
        var holds=Array.isArray(reservation.holds)?reservation.holds:[];
        if(!holds.length)throw new Error('Central availability could not be reserved.');
        holdIds=holds.map(function(hold){return hold.holdId}).filter(Boolean);
        applyCentralHolds(payload,items,holds);
      }

      var root=shopRoot();
      var clear=await fetch(root+'cart/clear.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'}
      });
      if(!clear.ok)throw new Error((await readError(clear))||'Unable to reset the booking cart.');

      var add=await fetch(root+'cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:items})
      });
      if(!add.ok)throw new Error((await readError(add))||'Unable to add items to cart.');

      var updateBody={};
      if(payload.note!==undefined&&payload.note!==null)updateBody.note=String(payload.note);
      var attributes=normalizeAttributes(payload);
      if(Object.keys(attributes).length)updateBody.attributes=attributes;

      if(Object.keys(updateBody).length){
        var update=await fetch(root+'cart/update.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify(updateBody)
        });
        if(!update.ok)throw new Error((await readError(update))||'Unable to save booking details.');
      }

      if(window.PMYTracking&&typeof window.PMYTracking.beginCheckout==='function'){
        window.PMYTracking.beginCheckout(items,{
          checkout_entry:'native_checkout_start'
        });
      }
      window.location.assign(root+'checkout'+checkoutPrefill(payload));
      return true;
    }catch(error){
      if(holdIds.length)await releaseCentralHolds(holdIds);
      throw error;
    }
  }

  window.PMYNativeCheckout={start:start};
})();
